import axios from "../../AxiosInstance";

//commanURL's
const BillingbaseUrl = '/operation';
const MasterbaseUrl = '/master';
const billingmasterUrl = 'master/billing';
const ReportsbaseUrl = '/Reports';

class OperationReportService {
    selectBranchDetails() {
        return axios.get(MasterbaseUrl + '/selectBranchDetails')
    }
    getEmployeeDetails() {
        return axios.get(MasterbaseUrl + '/getEmployeeDetails')
    }
    getDocumentationEmployeeReport(details) {
        return axios.post(ReportsbaseUrl + '/getDocumentationEmployeeReport', details)
    }
    getBillingDepEmployeeReport(details) {
        return axios.post(ReportsbaseUrl + '/getBillingDepEmployeeReport', details)
    }
    getFundReqEmployeeReport(details) {
        return axios.post(ReportsbaseUrl + '/getFundReqEmployeeReport', details)
    }
    getPaymentExpenseEmployeeReport(details) {
        return axios.post(ReportsbaseUrl + '/getPaymentExpenseEmployeeReport', details)
    }
    getEmployeeReport(details) {
        return axios.post(BillingbaseUrl + '/getEmployeeReport', details)
    }
    getCustomerBasedCustomerType(Importer) {
        return axios.get(MasterbaseUrl + '/getCustomerBasedCustomerType?customerType=' + Importer)
    }
    getBillAndNonBillReport(details) {
        return axios.post(ReportsbaseUrl + '/getBillAndNonBillReport', details)
    }
    getCustomLocation() {
        return axios.get(billingmasterUrl + '/getCustomLocation')
    }
    getExpenseReport(details) {
        return axios.post(BillingbaseUrl + '/getExpenseReport', details)
    }
    getProfitReport(details) {
        return axios.post(BillingbaseUrl + '/getProfitReport', details)
    }
    getChecklistExcelReport(details) {
        return axios.post(BillingbaseUrl + '/getChecklistExcelReport', details)
    }
    Excelwrite(details) {
        return axios.post(ReportsbaseUrl + '/write', details)
    }
    AccountExcelwrite(details) {
        return axios.post(ReportsbaseUrl + '/AccountExcelwrite', details)
    }
    AccountExcelwriteDash(details) {
        return axios.post(ReportsbaseUrl + '/AccountExcelwriteDash', details)
    }
    getEInvoiceReports(details) {
        return axios.post(BillingbaseUrl + '/b_sp_report_billing_e_invoice_excell', details)
    }
}
export default new OperationReportService();